import { useEffect, useState } from 'react';
import { formationApi } from '../api/formationApi';

/**
 * Ordre d'affichage imposé des financeurs.
 *
 * La liste renvoyée par l'API est triée par id, ce qui n'a aucun sens pour
 * l'utilisateur : DPC pèse l'essentiel des inscriptions et doit venir en
 * premier. Tout financeur absent de cette liste est affiché à la suite.
 */
export const FINANCIER_ORDER = [
  'DPC',
  'OPCO-EP',
  'Auto-financement',
  'FAFPM',
  'FIFPL-PCC',
  'FIFPL-PAIEMENT'
];

/**
 * Repli si l'appel échoue : mieux vaut des libellés que des « Financeur #4 ».
 */
const FALLBACK = [
  { id: 1, name: 'DPC' },
  { id: 4, name: 'FIFPL-PAIEMENT' },
  { id: 5, name: 'OPCO-EP' },
  { id: 6, name: 'FAFPM' },
  { id: 7, name: 'FIFPL-PCC' },
  { id: 8, name: 'Auto-financement' }
];

// La liste tient en six lignes et ne bouge jamais d'une session à l'autre :
// on la charge une fois pour toute la durée de la page, au lieu d'un appel
// par composant qui en a besoin.
let cached = null;
let pending = null;

const load = (token) => {
  if (cached) {
    return Promise.resolve(cached);
  }

  if (!pending) {
    pending = formationApi
      .getFinanciers(token)
      .then((response) => {
        cached = response && response.status === 200 && Array.isArray(response.data)
          ? response.data
          : FALLBACK;
        return cached;
      })
      .catch(() => {
        cached = FALLBACK;
        return cached;
      })
      .finally(() => {
        pending = null;
      });
  }

  return pending;
};

/**
 * Liste des financeurs, partagée entre tous les composants qui l'affichent.
 *
 * @returns {{ financiers: Array, loading: boolean }}
 */
const useFinanciers = () => {
  const [financiers, setFinanciers] = useState(cached || []);
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    if (cached) {
      return undefined;
    }

    let alive = true;

    load(localStorage.getItem('accessToken')).then((list) => {
      if (alive) {
        setFinanciers(list);
        setLoading(false);
      }
    });

    return () => {
      alive = false;
    };
  }, []);

  return { financiers, loading };
};

export default useFinanciers;
